// İki marka:
//  • BrandLogo  = UYGULAMA markası "Groot ONE" (metin wordmark) — giriş rozetleri / ayarlar (SaaS referansı).
//    Beyaz-etiket: tenant kendi logosunu yüklerse (logoUrl) onu gösterir.
//  • FirmLogo   = RESMİ FİRMA logosu (GROOT MARKET görseli, /public/groot-logo.png)
//    — müşteriye dönük yerler + kenar çubuğu: müşteri ekranı, fiş/fatura, sol menü.

const FIRM_LOGO = `${process.env.PUBLIC_URL || ""}/groot-logo.png`;

export function BrandLogo({ variant = "dark", size = 34, showText = true, className = "", logoUrl = "" }) {
  const light = variant === "light";
  if (logoUrl) {
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo">
        <img src={logoUrl} alt="Logo" style={{ height: Math.round(size * 1.1) }}
          className="w-auto max-w-[220px] object-contain" data-testid="brand-logo-img" />
      </div>
    );
  }
  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <div className="leading-none">
        <div className={`font-heading font-black tracking-tight ${light ? "text-slate-900" : "text-white"}`}
          style={{ fontSize: size }}>
          Groot<span className="text-brand-orange"> ONE</span>
        </div>
        {showText && (
          <div className={`mt-1 text-center font-black italic uppercase tracking-[0.22em] ${light ? "text-slate-500" : "text-white/70"}`}
            style={{ fontSize: Math.max(8, Math.round(size * 0.26)) }}>
            ERP
          </div>
        )}
      </div>
    </div>
  );
}

export function FirmLogo({ size = 40, className = "", logoUrl = "" }) {
  const src = logoUrl || FIRM_LOGO;
  return (
    <div className={`flex items-center ${className}`} data-testid="firm-logo">
      <img src={src} alt="GROOT MARKET" style={{ height: Math.round(size * 1.1) }}
        className="w-auto max-w-[300px] object-contain" data-testid="firm-logo-img"
        onError={(e) => { e.currentTarget.style.display = "none"; }} />
    </div>
  );
}

export default BrandLogo;
